// JSON-LD for the `rank` surface — leaderboard/podium share for a
// specific user. Schema-wise it's a Person (the ranked user) with the
// rank expressed as `award`.

import type { ShareSurface } from '@/lib/share/events';

import { resolveCanonicalOrigin } from '../origin';
import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildRankJsonLd(
  surface: Extract<ShareSurface, { kind: 'rank' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const personName = ctx.name ?? 'Morfi trader';
  const personUrl = `${resolveCanonicalOrigin()}/portfolio/${surface.userId}`;
  const awards: string[] = [];
  if (surface.pnlRank > 0) awards.push(`Rank #${surface.pnlRank} by PnL`);
  if (surface.volumeRank > 0) awards.push(`Rank #${surface.volumeRank} by volume`);
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: ctx.description ?? `${personName} on the Morfi leaderboard`,
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
      mainEntity: {
        '@type': 'Person',
        '@id': `${personUrl}#person`,
        name: personName,
        url: personUrl,
        image: ctx.ogImageUrl,
        ...(awards.length > 0 ? { award: awards } : {}),
      },
    },
  ];
}
